import { BOTS, type BotProfile } from '../lib/bots.ts';

/** Logo mark: a friendly knight on a sunny tile. */
export function LogoMark({ className = 'brand-mark' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 32 32" aria-hidden="true">
      <rect y="2" width="32" height="30" rx="10" fill="var(--accent-shadow)" />
      <rect width="32" height="30" rx="10" fill="var(--accent)" />
      <path
        d="M11 23.5h11.5v-2.2c0-3.6-1.2-6.4-2.4-8.6l1.6-1.4-.9-3.3-2.7 1.1c-1.1-.6-2.5-.8-3.8-.4-2.3.7-4.4 3.1-5 5.6l2.1 1.4 2.8-1.7c.4 1.6-.5 3.2-1.9 4.6-1 1-1.3 2.3-1.3 3.4v1.5Z"
        fill="var(--accent-contrast)"
      />
      <circle cx="16.3" cy="11.4" r="1.1" fill="var(--accent)" />
    </svg>
  );
}

/** The bot's animal character on its soft colour. */
export function BotAvatar({ bot }: { bot: BotProfile }) {
  return (
    <svg viewBox="0 0 40 40" role="img" aria-hidden="true">
      <rect width="40" height="40" fill={bot.accent} />
      <text x="20" y="21.5" textAnchor="middle" dominantBaseline="central" fontSize="25" fontFamily="var(--font-emoji)">
        {bot.emoji}
      </text>
    </svg>
  );
}

/** First letter of the player's name, or a smiley when they have none. */
export function PersonAvatar({ name }: { name: string }) {
  const initial = name.trim().charAt(0).toLocaleUpperCase();
  return initial ? <span>{initial}</span> : <span className="emoji">🙂</span>;
}

/** Difficulty pips: one lit per level, so kids can compare at a glance. */
export function Strength({ bot, large }: { bot: BotProfile; large?: boolean }) {
  return (
    <span className={`strength${large ? ' lg' : ''}`} aria-hidden="true">
      {BOTS.map((b) => (
        <i key={b.level} className={b.level <= bot.level ? 'on' : undefined} />
      ))}
    </span>
  );
}
